import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6 4C6 3.58579 6.33579 3.25 6.75 3.25H12.75C13.1642 3.25 13.5 3.58579 13.5 4C13.5 4.41421 13.1642 4.75 12.75 4.75H6.75C6.33579 4.75 6 4.41421 6 4ZM3.25 7.25C2.83579 7.25 2.5 7.58579 2.5 8C2.5 8.41421 2.83579 8.75 3.25 8.75C3.66421 8.75 4 8.41421 4 8C4 7.58579 3.66421 7.25 3.25 7.25ZM6.75 7.25C6.33579 7.25 6 7.58579 6 8C6 8.41421 6.33579 8.75 6.75 8.75H12.75C13.1642 8.75 13.5 8.41421 13.5 8C13.5 7.58579 13.1642 7.25 12.75 7.25H6.75ZM6 12C6 11.5858 6.33579 11.25 6.75 11.25H12.75C13.1642 11.25 13.5 11.5858 13.5 12C13.5 12.4142 13.1642 12.75 12.75 12.75H6.75C6.33579 12.75 6 12.4142 6 12ZM3.25 11.25C2.83579 11.25 2.5 11.5858 2.5 12C2.5 12.4142 2.83579 12.75 3.25 12.75C3.66421 12.75 4 12.4142 4 12C4 11.5858 3.66421 11.25 3.25 11.25ZM3.25 3.25C2.83579 3.25 2.5 3.58579 2.5 4C2.5 4.41421 2.83579 4.75 3.25 4.75C3.66421 4.75 4 4.41421 4 4C4 3.58579 3.66421 3.25 3.25 3.25Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }